import React from 'react';
import styled from '@emotion/styled';
import NavItem from './nav-item';

const SideBarNavRoot = styled.div({});

const SideBarNav = ({ title, contents, browserPath, rootPath }) => {
  const isActiveNavItem = path => {
    if (!browserPath) return false;

    const isBrowserOnTierListPage = browserPath.includes(`tier-list`);
    const navItemPathContainsTierList = path.includes(`tier-list`);

    if (isBrowserOnTierListPage && !navItemPathContainsTierList) return false;

    return browserPath.startsWith(`/${path}`);
  };

  return (
    <SideBarNavRoot>
      {title && rootPath && <NavItem title={title} primary to={rootPath} />}
      {contents.map(({ title: pageTitle, path, pages, iconURI }) => {
        return (
          path && <div key={path+pageTitle}>
            <NavItem
              title={pageTitle}
              path={path}
              iconURI={iconURI}
              to={path}
              pathname={browserPath}
              active={isActiveNavItem(path)}
            />
            {pages.map(({ path: subPagePath, title: subPageTitle }) => (
              <NavItem
                title={subPageTitle}
                to={subPagePath}
                pathname={browserPath}
                secondary
                active={isActiveNavItem(subPagePath)}
                key={subPagePath+pageTitle}
              />
            ))}
          </div>
        );
      })}
    </SideBarNavRoot>
  );
};

export default SideBarNav;
